import PropTypes from 'prop-types';
import CheckIcon from 'svg/check.svg';

const Checkbox = ({
  checked,
  extraClasses,
  disabled,
  id,
  label,
  name,
  test,
  reverse,
  required,
  onChange,
}) => (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label
    className={`c-control c-control--checkbox ${extraClasses || ''}`}
    htmlFor={id}
    data-cy={test}
  >
    <div
      className={` o-layout o-layout--gutter-tiny${
        reverse ? ' o-layout--reverse' : ''
      }`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="c-control__input u-visually-hidden"
        required={required}
      />
      <span
        className="c-control__indicator o-layout__cell o-layout__cell--fit"
        role="presentation"
      >
        <CheckIcon />
      </span>
      <span className="c-control__label o-layout__cell o-layout__cell--fill">
        {label}
      </span>
    </div>
  </label>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  extraClasses: PropTypes.string,
  disabled: PropTypes.bool,
  reverse: PropTypes.bool,
  required: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default Checkbox;
